/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestLidoSteth extends Contract<ITestLidoSteth> {
  getPooledEthByShares: Call<(_sharesAmount: BigNumberish) => BigNumber, ITestLidoSteth>
  'getPooledEthByShares(uint256)': Call<(_sharesAmount: BigNumberish) => BigNumber, ITestLidoSteth>
}

let ITestLidoStethBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestLidoStethBytecode = '0x';
}

// prettier-ignore
export const ITestLidoSteth = contract<ITestLidoSteth>(ITestLidoStethBytecode)`
  function getPooledEthByShares(uint256 _sharesAmount) view returns (uint256 ethAmount_)
`;